import s from "./styles";
import List from "../../components/common/ListWithMoreOptions";
import BottomPageSelectorWithPagination, {
  usePagination,
} from "../../components/common/BottomPageSelectorWithPagination";
import { usePaginatedData } from "../../helpers/hooks";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ClockSessionRowMap from "./Sessions/ClockSessionRowMap";

const ClockSessionsTable = ({
  userClockSessions,
  updateEnabled,
  setCurrentSession,
  selectStore,
}) => {
  const { t } = useTranslation();

  const { sorting, setSorting, pagination, setPagination } =
    usePagination("name");
  const actions = useMemo(
    () => ({
      in: t("containers.ClockSessions.in"),
      pause: t("containers.ClockSessions.pause"),
      // resume: t("containers.ClockSessions.resume"),
      // out: t("containers.ClockSessions.out"),
    }),
    []
  );

  const employeeDataSessions = usePaginatedData(
    userClockSessions,
    pagination,
    sorting,
    undefined,
    undefined,
    (item) => {
      // eslint-disable-next-line react/display-name
      return () => (
        <ClockSessionRowMap
          key={item._id}
          item={item}
          actions={actions}
          setCurrentSession={setCurrentSession}
          updateEnabled={updateEnabled}
          selectStore={selectStore}
        />
      );
    }
  );

  const columns = useMemo(() => {
    return [
      {
        title: t("containers.ClockSessions.start"),
        sortable: true,
        columnId: "sessionStart",
      },
      {
        title: t("containers.ClockSessions.end"),
        sortable: true,
        columnId: "sessionEnd",
      },
      {
        title: t("containers.ClockSessions.type"),
        sortable: true,
        columnId: "type",
      },
      {
        title: t("containers.ClockSessions.duration"),
        sortable: true,
        columnId: "type",
      },
      {
        title: t("containers.ClockSessions.additionalInformation"),
        sortable: true,
        columnId: "notes",
      },
      {
        title: "",
      },
    ];
  }, []);

  return (
    <>
      <s.ListContainer>
        <List
          width={"800px"}
          data={employeeDataSessions}
          columns={columns}
          sorting={sorting}
          moreOption={false}
          changeSorting={(columnId, order) => setSorting({ columnId, order })}
          tableStyle={{
            gridTemplateColumns: "6fr 6fr 6fr 6fr 8fr 8fr",
          }}
        />
      </s.ListContainer>
      <BottomPageSelectorWithPagination
        pagination={pagination}
        setPagination={setPagination}
        length={employeeDataSessions.length}
      />
    </>
  );
};

export default ClockSessionsTable;
